module.exports = __webpack_public_path__ + "img/pic1.485d9a2f.png";